export default {
  app: {
    title: 'Qiyun Data Workshop',
    subtitle: 'A platform for rental data crawling and analysis based on ke.com',
    footer: '© {year} Qiyun Data Workshop · Powered by Vue.js & FastAPI · All rights reserved'
  },
  menu: {
    home: 'Home',
    tasks: 'Crawler Tasks',
    ipManagement: 'IP Management',
    scheduledTasks: 'Scheduled Tasks',
    houses: 'Housing Data',
    analysis: 'Data Analysis',
    settings: 'System Settings'
  },
  home: {
    systemIntro: 'System Features',
    introText: 'This system is a rental data analysis platform based on Python technology stack, which crawls rental information from Beike website, processes and analyzes data using PySpark, and finally displays market insights in the form of visualization charts.',
    mainFeatures: 'Main Features:',
    dataCollection: 'Data Collection',
    dataCollectionDesc: 'Support rental data crawling in multiple cities, automatically parse key information such as house price, area, location, etc.',
    dataAnalysis: 'Data Analysis',
    dataAnalysisDesc: 'Use PySpark for multi-dimensional analysis of rental data, including area analysis, house type analysis, price distribution, etc.',
    visualization: 'Data Visualization',
    visualizationDesc: 'Visually display analysis results through ECharts, helping users quickly understand the rental market',
    quickStart: 'Quick Start:',
    step1: 'Create a new crawl task on the right, select a city and the number of pages to crawl',
    step2: 'After the crawl task is completed, view the details in the task list',
    step3: 'Click "View Data" to browse the crawled house information, or click "Analyze Data" for data analysis',
    step4: 'View the generated visualization charts on the data analysis page',
    createTask: 'Create New Crawl Task',
    viewAnalysis: 'View Analysis',
    step1Title: 'Create Task',
    step2Title: 'View Results',
    step3Title: 'Analyze Data',
    city: 'City',
    selectCity: 'Please select a city',
    crawlPages: 'Pages to Crawl',
    startCrawling: 'Start Crawling',
    reset: 'Reset',
    recentTasks: 'Recent Crawl Tasks',
    viewAll: 'View All',
    noTasks: 'No crawl tasks yet',
    status: 'Status:',
    startTime: 'Start Time:',
    houseCount: 'Houses:',
    view: 'View',
    taskStatus: {
      inProgress: 'In Progress',
      completed: 'Completed',
      failed: 'Failed'
    },
    fetchTasksFailed: 'Failed to fetch recent tasks',
    taskCreatedSuccess: 'Successfully created crawler task',
    请设置爬取页数: 'Please set number of pages to crawl',
    爬虫任务创建成功: 'Crawler task created successfully',
    taskCreateFailed: 'Failed to create crawler task',
    fetchCitiesFailed: 'Failed to fetch cities list'
  },
  notFound: 'Page Not Found',
  nav: {
    home: 'Home',
    taskList: 'Task List',
    scheduledTasks: 'Scheduled Tasks',
    scheduledtasks: 'Scheduled Tasks',
    ipManagement: 'IP Management',
    houseList: 'House List',
    analysis: 'Data Analysis',
    userprofile: 'User Profile',
    usersettings: 'User Settings',
    systemsettings: 'System Settings'
  },
  auth: {
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    forgotPasswordTitle: 'Reset Password',
    forgotPasswordSubtitle: 'Enter your email and we\'ll send you a verification code',
    sendResetLink: 'Send Reset Link',
    sendVerificationCode: 'Send Verification Code',
    resetPasswordTitle: 'Reset Password',
    resetPasswordSubtitle: 'Please enter verification code and new password',
    verificationCode: 'Verification Code',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    resendCode: 'Resend Code',
    rememberedPassword: 'Remembered your password?',
    registerTitle: 'Create an Account',
    registerSubtitle: 'Fill in the details to sign up',
    loginTitle: 'Welcome Back',
    loginSubtitle: 'Please sign in to your account',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    rememberMe: 'Remember me',
    forgotYourPassword: 'Forgot password?',
    noAccount: 'Don\'t have an account?',
    alreadyHaveAccount: 'Already have an account?',
    agreeTerms: 'I agree to the Terms of Service and Privacy Policy',
    termsLink: 'Terms of Service',
    haveAccount: 'Already have an account?',
    createAccount: 'Create Account',
    resetPassword: 'Reset Password'
  },
  user: {
    profile: 'Profile',
    profileDesc: 'View and edit your personal information',
    settings: 'Settings',
    settingsDesc: 'Manage your account settings and preferences',
    logout: 'Logout',
    username: 'Username',
    email: 'Email',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    currentPasswordPlaceholder: 'Enter your current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmNewPassword: 'Confirm New Password',
    confirmPasswordPlaceholder: 'Enter new password again',
    saveChanges: 'Save Changes',
    changeAvatar: 'Change Avatar',
    deleteAccount: 'Delete Account',
    deleteAccountConfirmation: 'Confirm Account Deletion',
    deleteAccountWarning: 'Warning: This action will permanently delete your account and all associated data. This cannot be undone.',
    deleteConfirmation: 'Confirmation',
    deleteConfirmationPlaceholder: 'Type DELETE to confirm',
    passwordRequired: 'Password is required',
    confirmationRequired: 'Confirmation text is required',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    notificationSettings: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive emails about system updates and important notifications',
    taskCompletionNotifications: 'Task Completion Notifications',
    taskCompletionNotificationsDesc: 'Receive notifications when crawler tasks are completed',
    displaySettings: 'Display Settings',
    language: 'Language',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    themeDesc: 'Choose the display theme for the application',
    accountSettings: 'Account Settings',
    dataSharing: 'Data Sharing',
    dataSharingDesc: 'Allow the system to collect anonymous usage data to improve services',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Actions below can lead to irreversible data loss'
  },
  settings: {
    systemSettings: 'System Settings',
    systemSettingsDesc: 'Manage system settings and configurations',
    databaseSettings: 'Database Settings',
    databaseConfig: 'Database Configuration',
    dataManagement: 'Data Management',
    systemInfo: 'System Information',
    systemStatus: 'System Status',
    about: 'About',
    
    dbHost: 'Host',
    dbPort: 'Port',
    dbName: 'Database',
    dbUser: 'Username',
    dbPassword: 'Password',
    
    purgeData: 'Purge Data',
    purgeDataDesc: 'Delete all crawled property data and task records',
    purgeDataConfirmation: 'Confirm Data Purge',
    purgeDataWarning: 'This action will permanently delete all property data and task records, and cannot be recovered.',
    purgeConfirmation: 'I understand the risks and confirm to purge all data',
    
    exportData: 'Export Data',
    exportDataDesc: 'Export all system settings and configuration data',
    
    version: 'Version',
    lastUpdate: 'Last Update',
    apiStatus: 'API Status',
    dbStatus: 'Database Status',
    userCount: 'Users',
    houseCount: 'Properties',
    taskCount: 'Tasks',
    startupTime: 'Startup Time',
    uptime: 'Uptime',
    diskUsage: 'Disk Usage',
    
    adminOnlyNotice: 'Only administrators can modify database settings',
    resetToDefault: 'Reset to Default',
    saveChanges: 'Save Changes',
    
    aboutText: 'This is a rental data analysis system based on Vue.js and FastAPI, capable of crawling, storing, and analyzing rental data.',
    sourceCode: 'Source Code',
    documentation: 'Documentation',
    reportBug: 'Report Bug'
  },
  scheduledTasks: {
    title: 'Scheduled Tasks',
    createTask: 'Create Task',
    editTask: 'Edit Task',
    taskName: 'Task Name',
    city: 'City',
    selectCity: 'Select City',
    pagesToCrawl: 'Pages to Crawl',
    schedule: 'Schedule',
    nextRun: 'Next Run',
    status: 'Status',
    actions: 'Actions',
    runTime: 'Run Time',
    weekday: 'Weekday',
    monthDay: 'Day of Month',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    nameRequired: 'Please enter a task name',
    nameLength: 'Length should be 2 to 100 characters',
    cityRequired: 'Please select a city',
    pagesRequired: 'Please enter pages to crawl',
    pagesRange: 'Pages must be between 1 and 100',
    timeRequired: 'Please select a time',
    warning: 'Warning',
    confirm: 'Confirm',
    cancel: 'Cancel',
    confirmDeleteTask: 'Are you sure you want to delete task {name}?',
    deleteSuccess: 'Delete successful',
    deleteError: 'Delete failed',
    createSuccess: 'Create successful',
    updateSuccess: 'Update successful',
    saveError: 'Save failed',
    fetchTasksError: 'Failed to fetch tasks',
    fetchCitiesError: 'Failed to fetch cities',
    everyDayAt: 'Daily at {time}',
    everyWeekAt: '{day} at {time}',
    everyMonthAt: 'Monthly on day {day} at {time}'
  },
  cancel: 'Cancel',
  ipManagement: {
    currentIp: 'Current IP Address',
    refreshIp: 'Refresh IP',
    proxyPool: 'Proxy IP Pool',
    ipSettings: 'IP Settings',
    addProxy: 'Add Proxy',
    ipAddress: 'IP Address',
    port: 'Port',
    location: 'Location',
    status: 'Status',
    latency: 'Latency',
    lastUsed: 'Last Used',
    actions: 'Actions',
    test: 'Test',
    delete: 'Delete',
    rotationStrategy: 'IP Rotation Strategy',
    rotationInterval: 'Rotation Interval',
    maxFailures: 'Max Failures',
    autoAddProxies: 'Auto Add Proxies',
    minutes: 'minutes',
    failures: 'failures',
    saveSettings: 'Save Settings',
    resetSettings: 'Reset Settings',
    username: 'Username',
    password: 'Password',
    strategies: {
      manual: 'Manual Switching',
      time: 'Time-based Rotation',
      failure: 'Failure-based Rotation',
      request: 'Request-based Rotation'
    },
    statusTypes: {
      active: 'Active',
      inactive: 'Inactive',
      error: 'Error'
    }
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete'
  },
  taskList: {
    title: 'Crawler Task List',
    refresh: 'Refresh',
    status: {
      inProgress: 'In Progress',
      completed: 'Completed',
      failed: 'Failed'
    },
    messages: {
      taskInProgress: 'Task is in progress, cannot view data yet',
      cannotAnalyzeInProgress: 'Task is in progress, cannot analyze data yet',
      noDataToAnalyze: 'No successfully crawled data to analyze',
      analysisStarted: 'Data analysis task started',
      analysisStartFailed: 'Failed to start data analysis task',
      cannotDeleteInProgress: 'Cannot delete a task that is in progress',
      confirmDelete: 'Are you sure you want to delete the {city} crawler task with ID {id}? This action will delete the task and related data, and cannot be undone.',
      deleteConfirmTitle: 'Delete Confirmation',
      deleteSuccess: 'Task deleted successfully',
      deleteFailed: 'Failed to delete task',
      fetchTasksFailed: 'Failed to fetch task list'
    },
    columns: {
      id: 'ID',
      city: 'City',
      status: 'Status',
      startTime: 'Start Time',
      endTime: 'End Time',
      totalItems: 'Total Items',
      successItems: 'Success Items',
      progress: 'Progress',
      actions: 'Actions'
    },
    crawlerRunning: 'Crawler Task Initializing',
    waitForCrawler: 'Crawler task just started, database is processing, please check the task list later',
    remainingTime: 'Estimated time remaining',
    viewAnyway: 'View Anyway'
  }
}; 